/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PagingDtoFromJSON, PagingDtoToJSON, } from './PagingDto';
/**
 * @export
 */
export const AgendaCommercialeSearchDtoModalitaContattoEnum = {
    Mail: 'MAIL',
    Telefono: 'TELEFONO',
    Incontro: 'INCONTRO'
};
/**
 * @export
 */
export const AgendaCommercialeSearchDtoEsitoEnum = {
    Annullata: 'ANNULLATA',
    Positivo: 'POSITIVO',
    Negativo: 'NEGATIVO',
    Neutro: 'NEUTRO',
    DaEseguire: 'DA_ESEGUIRE'
};
/**
 * @export
 */
export const AgendaCommercialeSearchDtoStatoAttivitaEnum = {
    Completate: 'COMPLETATE',
    ScaduteSenzaEsito: 'SCADUTE_SENZA_ESITO',
    PianificateOggi: 'PIANIFICATE_OGGI',
    Future: 'FUTURE',
    NonClassificate: 'NON_CLASSIFICATE'
};
/**
 * @export
 */
export const AgendaCommercialeSearchDtoSortByEnum = {
    FkCliente: 'FK_CLIENTE',
    FkStrutturaBusiness: 'FK_STRUTTURA_BUSINESS',
    ActionDate: 'ACTION_DATE',
    LastmodifiedDate: 'LASTMODIFIED_DATE'
};
/**
 * @export
 */
export const AgendaCommercialeSearchDtoSortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
};
/**
 * Check if a given object implements the AgendaCommercialeSearchDto interface.
 */
export function instanceOfAgendaCommercialeSearchDto(value) {
    return true;
}
export function AgendaCommercialeSearchDtoFromJSON(json) {
    return AgendaCommercialeSearchDtoFromJSONTyped(json, false);
}
export function AgendaCommercialeSearchDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fkCliente': json['fkCliente'] == null ? undefined : json['fkCliente'],
        'fkStrutturaBusiness': json['fkStrutturaBusiness'] == null ? undefined : json['fkStrutturaBusiness'],
        'denominazioneStrutturaBusiness': json['denominazioneStrutturaBusiness'] == null ? undefined : json['denominazioneStrutturaBusiness'],
        'modalitaContatto': json['modalitaContatto'] == null ? undefined : json['modalitaContatto'],
        'esito': json['esito'] == null ? undefined : json['esito'],
        'statoAttivita': json['statoAttivita'] == null ? undefined : json['statoAttivita'],
        'actionDateDa': json['actionDateDa'] == null ? undefined : (new Date(json['actionDateDa'])),
        'actionDateA': json['actionDateA'] == null ? undefined : (new Date(json['actionDateA'])),
        'isRicercaEstesa': json['isRicercaEstesa'] == null ? undefined : json['isRicercaEstesa'],
        'sortBy': json['sortBy'] == null ? undefined : json['sortBy'],
        'sortDirection': json['sortDirection'] == null ? undefined : json['sortDirection'],
        'paging': json['paging'] == null ? undefined : PagingDtoFromJSON(json['paging']),
    };
}
export function AgendaCommercialeSearchDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'fkCliente': value['fkCliente'],
        'fkStrutturaBusiness': value['fkStrutturaBusiness'],
        'denominazioneStrutturaBusiness': value['denominazioneStrutturaBusiness'],
        'modalitaContatto': value['modalitaContatto'],
        'esito': value['esito'],
        'statoAttivita': value['statoAttivita'],
        'actionDateDa': value['actionDateDa'] == null ? undefined : ((value['actionDateDa']).toISOString().substring(0, 10)),
        'actionDateA': value['actionDateA'] == null ? undefined : ((value['actionDateA']).toISOString().substring(0, 10)),
        'isRicercaEstesa': value['isRicercaEstesa'],
        'sortBy': value['sortBy'],
        'sortDirection': value['sortDirection'],
        'paging': PagingDtoToJSON(value['paging']),
    };
}
